(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('monthToStringFilter', monthToString);

    /** @ngInject */
    function monthToString(getMonthsService) {
        return function(text) {
			return getMonthsService.getMonthList()[text-1];
		};

    }

})();
